// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2Ljt3","signatureButtonsRight":"ModalSign_signatureButtonsRight__36FMw"};